package b2d.userdata

class TrapUserData {

    var wasTouched = false
        private set

    fun setTouched(value: Boolean) {
        wasTouched = value
    }

}
